import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '@ion/iam';

/**
 * Guard that only allows navigation when a new password is required.
 * If a new password is not required, redirects to the home page.
 */
export const isNewPasswordRequiredGuard = (): boolean | UrlTree => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (authService.isNewPasswordRequired()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
